import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

const API_URL = getApiBaseUrl();

// Crear una instancia de Axios
const api = axios.create({
  baseURL: API_URL,
});

// Configurar un interceptor para agregar el token a cada solicitud
api.interceptors.request.use(
  (config) => {
    const token = secureStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Usar la instancia 'api' para todas las solicitudes
 const fetchAdelantos = async () => {
  try {
    const response = await api.get('adelanto'); // <-- use api instance here
    return response.data;
  } catch (error) {
    console.error("Error fetching adelantos:", error);
    throw error;
  }
};

const PostDatosAdelanto = async (datos) => {
  try {
    const response = await api.post('adelanto', datos);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const fetchAdelantoView = async (month, year) => {
  try {
    const response = await api.get('AdelantoView2', {
      params: { month, year }, // se envían como query params
    });
    console.log("🚀 ~ fetchAdelantoView ~ response:", response)
    return response.data;
  } catch (error) {
    console.error("Error fetching AdelantoView:", error);
    throw error;
  }
};

export const fetchAdelantoPreview = async () => {
  try {
    const response = await api.get('adelanto/preview');
    return response.data;
  } catch (error) {
    console.error("Error fetching preview:", error);
    throw error;
  }
};



export { PostDatosAdelanto, fetchAdelantos, fetchAdelantoView };